<template>
  <div class="relative p-8">
    <div class="w-full bg-white flex justify-start py-3" style="color: #414066">
      <h1 class="font-bold m-4" style="font-size: 1.5rem;">Order {{ order.number }} </h1>
    </div>
    <div class="order-form w-full bg-white py-3 px-6" style="color: #414066">
      <form @submit.prevent="saveChanges" class="block">
        <div class="flex justify left w-full">
          <div class="sm:w-full md:w-1/2 lg:w-1/3 mx-4">
            <label>Client Address</label>
            <input v-model="order.client_address" type="text" class="admin-input" required/>
          </div>
          <div class="w-36 mx-4" >
            <label>Type</label>
            <select v-model="order.type" class="admin-input">
              <option :value="1">Private</option>
              <option :value="2">Business</option>
            </select>
          </div>
          <div class="sm:w-full md:w-1/2 lg:w-1/3 mx-4">
            <label>Affiliate code</label>
            <input v-model="order.affiliate_code" type="text" class="admin-input"/>
          </div>
        </div>
        <hr class="mt-8">
        <div class="w-full flex justify-left mt-8 mb-4 "> 
          <h2 class="text-2xl font-xl">Payment</h2>
        </div>
        <div class="flex justify-left w-full">
          <div class="sm:w-full md:w-1/2 lg:w-1/3 mx-4">
            <label>Tx Hash</label>
            <input v-model="order.tx_hash" type="text" class="admin-input"/>
          </div>
          <div class="w-36 mx-4">
            <label>Amount</label>
            <input v-model="order.amount" type="number" class="admin-input" required/>
          </div>
          <div class="w-36 mx-4" >
            <label>Currency</label>
            <select v-model="order.currency" class="admin-input">
              <option value="XRP">XRP</option>
              <option value="XBANK">XBANK</option>
            </select>
          </div>
          <div class="w-36 mx-4">
            <label>Payment Status</label>
            <select v-model="order.payment_status" class="admin-input">
              <option :value="0">Pending</option>
              <option :value="1">Completed</option>
            </select>
          </div>
        </div>
        <hr class="mt-8">
        <div class="w-full flex justify-left mt-8 mb-4 "> 
          <h2 class="text-2xl font-xl">Slot</h2>
        </div>
        <div class="flex justify-left w-full">
          <div class="sm:w-full md:w-1/3 lg:w-1/3 mx-4">
            <label>Display text</label>
            <input v-model="order.display_text" type="text" class="admin-input"/>
          </div>
          <div class="sm:w-full md:w-1/3 lg:w-1/3 mx-4">
            <label>Url</label>
            <input v-model="order.url" type="url" class="admin-input"/>
          </div>

          <div class="sm:w-full md:w-1/3 lg:w-1/3 mx-4" style="max-width: 200px;">
            <div v-if="!imgUrl" class="image-select flex flex-col justify-end h-full">
              <a class="btn btn-outline-light" @click.prevent="launchChooseFile" style="float: bottom; margin-bottom: 10px;">Upload image</a>
            </div>
            <input v-model="order.image_status" type="number" class="admin-input" hidden/>
            <div v-if="imgUrl" class="image-wrapper flex items-center justify-center">
              <button 
                @click="deleteImage" 
                class="absolute text-gray-600 hover:text-gray-900 btn-close btn-remove"
                aria-label="X"
              >
                Remove
              </button>
              <img :src="imgUrl" class="preview"/>
            </div>
              <input 
                ref="imageInput" 
                type="file" 
                name="image" 
                class="image" 
                accept="image/*"
                single 
                @change="handleImageUpload"
                hidden
              />
          </div>



        </div>
        <hr class="mt-8">
        <div class="w-full flex justify-left mt-8 mb-4 "> 
          <h2 class="text-2xl font-xl">Coordinates</h2>
        </div>
        <div class="flex justify-left w-full">
          <div class="w-24 ml-4 mr-1">
            <label>Left</label>
            <input v-model="order.coords_x_left" type="number" step="1" min="0" class="admin-input" required/>
          </div>
          <div class="w-24 ml-1 mr-4">
            <label>Right</label>
            <input v-model="order.coords_x_right" type="number" step="1" min="0" class="admin-input" required/>
          </div>
          <div class="w-24 ml-4 mr-1">
            <label>Top</label>
            <input v-model="order.coords_y_top" type="number" step="1" min="0" class="admin-input" required/>
          </div>
          <div class="w-24 ml-1 mr 4">
            <label>Bottom</label>
            <input v-model="order.coords_y_bottom" type="number" step="1" min="0" class="admin-input" required/>
          </div>
          <div class="w-36 ml-8">
            <label>Size</label>
            <input v-bind:value="(order.coords_x_right - order.coords_x_left + 1 || 0) + 'x' + (order.coords_y_bottom - order.coords_y_top + 1 || 0) + 'px'" type="text" class="admin-input" readonly>
          </div>
        </div>
        <hr class="mt-8">
        <div class="w-full flex justify-left mt-8 mb-4 "> 
          <h2 class="text-2xl font-xl">Contacts</h2>
        </div>
        <div class="flex justify left w-full">
          <div class="sm:w-full md:w-1/2 lg:w-1/3 mx-4">
            <label>E-mail</label>
            <input v-model="order.email" type="email" class="admin-input"/>
          </div>
          <div class="sm:w-full md:w-1/2 lg:w-1/3 mx-4">
            <label>X</label>
            <input v-model="order.twitter" type="text" class="admin-input"/>
          </div>
          <div class="sm:w-full md:w-1/2 lg:w-1/3 mx-4">
            <label>Dicord</label>
            <input v-model="order.discord" type="text" class="admin-input"/>
          </div>
        </div>
        <hr class="mt-8">
        <div class="w-full flex justify-left mt-8 mb-4 "> 
          <h2 class="text-2xl font-xl">Comments</h2>
        </div>
        <div class="flex justify-left w-full">
          <textarea v-model="order.comment"  rows="4" class="admin-input w-full"></textarea>
        </div>
        <div class="flex justify-between mt-8">
          <div>
            <a @click="deleteOrder(order.id)" class="btn btn-light items-center btn-danger btn-admin">Delete <img src="../assets/images/trash-can.svg"/></a>
          </div>
          <div class="flex justify-end">
            <a :href="`/admin/orders`" class="btn btn-secondary mr-8 items-center btn-admin" style="text-decoration: none;">Return <img src="../assets/images/return.svg"/></a>
            <a @click="mintNft(order.id)" class="mr-16 btn btn-light items-center btn-outline-light btn-admin">
              <span v-if="!minting" >Mint NFT </span>
              <img v-if="!minting" src="../assets/images/blockchain-blue.svg"/>
              <span v-if="minting" class="mr-4">Minting </span>
              <div v-if="minting" class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </a>
            <button type="submit" class="btn btn-light items-center btn-admin">Save Changes <img src="../assets/images/save.svg"/></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import { toast } from "vue3-toastify";

const router = useRouter();
const route = useRoute();
const order = ref({});
const imgUrl = ref({});
const imageInput = ref(null);
const newImageSelected = ref(false);
const apiBase = process.env.VUE_APP_API_ADMIN_BASE;
const uploadsUrl = process.env.VUE_APP_API_IMAGE;
//const nftUri = ref({});
//const transactionHash = ref({});
//const transactionUrl = ref({});
//let loading = false;
const minting = ref(false);

const launchChooseFile = async () => {
  imageInput.value.click();
}

const handleImageUpload = async () => {
  const file = event.target.files[0];
      
  if (!file) {
    toast.error('No image seleted.\nTry again.', { icon: false, });
    order.value.image = null;
    imgUrl.value = null;
    newImageSelected.value = false;
    return;
  }

  // Validate file type (only allow images)
  if (!file.type.startsWith('image/')) {
    toast.error('Only image files are allowed.\nTry again.', { icon: false, });
    order.value.image = null;
    imgUrl.value = null;
    newImageSelected.value = false;
    return;
  }

  // Validate file size (max 5 MB)
  if (file.size > 5 * 1024 * 1024) {
    toast.error('Image is too large.\n5 MB are allowed.', { icon: false, });
    order.value.image = null;
    imgUrl.value = null;
    newImageSelected.value = false;
    return;
  }

  imgUrl.value = URL.createObjectURL(file);
  order.value.image = file;
  newImageSelected.value = true;
  console.log('file=' + file)
  console.log('imgUrl.value' + imgUrl.value)
}

const deleteImage = () => {
  order.value.image = null;
  imgUrl.value = null;
  newImageSelected.value = false;
  imageInput.value.value = "";
}

const fetchOrder = async () => {
  try {
    const token = localStorage.getItem("token"); // Get the token from localStorage

    const response = await axios.get(`${apiBase}/orders/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${token}`  // Send token in Authorization header
      }
    });
    
    if(response.status === 200) {
      if(response.data.order) {
        order.value = response.data.order;
        imgUrl.value = uploadsUrl + '/' + order.value.image_name || null;
      } else {
        toast.warning('Failed to load order.\nTry reloading.', { icon: false, });
      }
    }
  } catch (error) {
    if(error.status === 401 || error.status === 403){
      toast.warning('Login for access.', { icon: false, });
    } else {
      toast.error('There was an error while loading order.\nTry reloading.', { icon: false, })
    }
  }
};

const saveChanges = async () => {
  try {
    // Create FormData object
    const formData = new FormData();
    formData.append('id', order.value.id || null);
    formData.append('number', order.value.number || null);
    formData.append('client_address', order.value.client_address || null);
    formData.append('amount', order.value.amount || null);
    formData.append('coords_x_left', order.value.coords_x_left || null);
    formData.append('coords_y_top', order.value.coords_y_top || null);
    formData.append('coords_x_right', order.value.coords_x_right || null);
    formData.append('coords_y_bottom', order.value.coords_y_bottom || null);
    formData.append('url', order.value.url || null);
    formData.append('display_text', order.value.display_text || null);
    formData.append('email', order.value.email) || null;
    formData.append('twitter', order.value.twitter) || null;
    formData.append('discord', order.value.discord || null);
    formData.append('affiliate_code', order.value.affiliate_code || null);
    formData.append('tx_hash', order.value.tx_hash || null);
    formData.append('type', order.value.type || null);
    formData.append('currency', order.value.currency || null);
    formData.append('payment_status', order.value.payment_status || null);
    formData.append('comment', order.value.comment || null);
    formData.append('image_status', order.value.image_status || null);
    if(newImageSelected.value) {
      formData.append('image', order.value.image || null);
    }

    const token = localStorage.getItem("token"); // Get the token from localStorage

    const response = await axios.put(`${apiBase}/orders`, formData, {
      headers: {
        Authorization: `Bearer ${token}`  // Send token in Authorization header
      }
    });

    if(response.status === 200) {
      if(response.data.success) {
        toast.success('Changes saved!', { icon: false });
      } else {
        toast.warning('Something went wrong.\nCheck order and try again.', { icon: false, });
      }
    }

    if (response.data.level === 'warning') {
      response.data.messages.forEach(msg => {
        toast.warning(msg, { icon: false });
      });
    } else if (response.data.level === 'error') {
      response.data.messages.forEach(msg => {
        toast.error(msg, { icon: false });
      });
    }
  } catch (error) {
    // Handle error
    toast.error('There was a problem saving your order.\nCheck your profile or contact us.', { icon: false });
    console.error('Error adding order:', error);
  }
}

const deleteOrder = async () => {
  try {
    const token = localStorage.getItem("token"); // Get the token from localStorage

    const response = await axios.delete(`${apiBase}/orders/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${token}`  // Send token in Authorization header
      }
    });
    
    if(response.status === 200) {
      toast.success('Order deleted.', { icon: false, });
      router.push("/admin/orders");
    }
  } catch (error) {
    if(error.status === 401 || error.status === 403){
      toast.warning('Login for access.', { icon: false, });
    } else {
      toast.error('There was an error while deleting order.\nTry again.', { icon: false, })
    }
  }
};

const mintNft = async (orderId) => {
  if(minting.value === true) {
    return;
  }

  minting.value = true;
  console.log('minting: ' + minting.value)
  try {
    const token = localStorage.getItem("token"); // Get the token from localStorage

    const response = await axios.post(
      `${apiBase}/mint-nft`,
      {
        orderId: orderId
      }, // No body in this POST request
      {
        headers: {
          Authorization: `Bearer ${token}` // Correctly placed in config
        }
      }
    );
    
    if(response.status === 200) {
      toast.success('Order deleted.', { icon: false, });
      router.push("/admin/orders");
    }
    minting.value = false;
  } catch (error) {
    minting.value = false;
    if(error.status === 401 || error.status === 403){
      toast.warning('Login for access.', { icon: false, });
    } else {
      toast.error('There was an error while deleting order.\nTry again.', { icon: false, })
    }
  }
};

onMounted(() => {
  if (!localStorage.getItem("token")) {
    console.log("No token");
    router.push("/login");
  }
  fetchOrder();
});

</script>

<style scoped>
label {
  float: left;
}
</style>
